export default "__VITE_ASSET__DMkVdJ$u__"